<template>
  <div class="grid grid-rows-[auto_1fr] overflow-hidden h-full">
    <ThreadsNav :show-back="true" :show-center="false">
      <template #right>
        <button
          class="btn btn-primary btn-sm rounded"
          @click="
            router.push({
              name: 'mateWishEdit',
              query: {
                from: 'mateWishHome',
              },
            })
          "
        >
          {{ $t(`mateWish.new`) }}
        </button>
      </template>
    </ThreadsNav>
    <div class="flex-1 overflow-hidden mate-wish-home-list">
      <VanTabs v-model:active="status" class="h-full overflow-hidden">
        <VanTab
          v-for="item in statusList"
          :key="item"
          :name="item"
          :title="$t(`mateWish.status.${item}`)"
          class="flex w-full"
        >
          <thread-list
            :ref="
              (el) => {
                scrollerMap[item] = el as unknown as ThreadListInstance;
              }
            "
            :on-pull-load="reload"
            :on-scroll-load="loadMateWish"
            :need-login="false"
            class="w-full"
            @on-scroll="
              (h) => {
                heightMap[item] = h;
              }
            "
          >
            <!-- 30天横幅提示 -->
            <VanNoticeBar
              v-if="showTimeLimitBanner && status !== 1"
              left-icon="info-o"
              mode="closeable"
              class="mx-4 mt-4 rounded-lg"
              @close="clickKnow"
              :scrollable="false"
              :wrapable="true"
            >
              <div class="flex justify-between w-full gap-4">
                仅展示近30天祈愿图片
                <span
                  class="text-primary"
                  @click="
                    router.push({
                      name: 'gallery',
                    })
                  "
                >
                  全部图片
                </span>
              </div>
            </VanNoticeBar>

            <div
              v-for="mateWishItem in listMap[item]"
              :key="mateWishItem.id"
              class="bg-base-100 rounded-xl shadow-sm border border-base-300 mx-4 mb-4 overflow-hidden"
            >
              <!-- 图片区域 -->
              <div
                v-if="mateWishItem.resultImagezz?.[0]?.url"
                class="relative bg-base-200 cursor-pointer"
              >
                <img
                  :src="mateWishItem.resultImagezz?.[0]?.url"
                  @click="clickToDetail(mateWishItem)"
                  alt="Wish Detail"
                  class="w-full h-full object-cover"
                  crossorigin="anonymous"
                />

                <!-- 状态标签 -->
                <!-- <div class="absolute top-3 right-3">
                  <div
                    v-if="mateWishItem.status === 1"
                    class="badge badge-warning gap-1 shadow-sm"
                  >
                    <div
                      class="w-2 h-2 rounded-full bg-warning animate-pulse"
                    ></div>
                    生成中
                  </div>
                  <div
                    v-else-if="mateWishItem.status === 2"
                    class="badge badge-success gap-1 shadow-sm"
                  >
                    <div class="w-2 h-2 rounded-full bg-success"></div>
                    已完成
                  </div>
                </div> -->

                <!-- 多图片指示器 -->
                <div
                  v-if="
                    mateWishItem.resultImagezz &&
                    mateWishItem.resultImagezz.length > 1
                  "
                  class="absolute bottom-3 right-3 bg-black/60 text-white px-2 py-1 rounded-full text-xs"
                >
                  {{ mateWishItem.resultImagezz.length }} 张图片
                </div>
              </div>

              <!-- 内容区域 -->
              <div class="p-4 space-y-3">
                <!-- 描述文本 -->

                <!-- 参考图列表 -->
                <div
                  v-if="
                    mateWishItem.status !== 2 &&
                    mateWishItem.referenceImagezz?.length
                  "
                  class="mt-2"
                >
                  <!-- <div class="text-xs text-base-content/60 font-medium mb-1">
                    参考图
                  </div> -->
                  <div class="flex gap-1 flex-wrap mt-2">
                    <div
                      v-for="img in mateWishItem.referenceImagezz"
                      :key="img.id"
                      class="h-10 aspect-[3/4] rounded overflow-hidden bg-base-200 flex-shrink-0"
                    >
                      <BaseImg
                        :url="img.url"
                        fit="cover"
                        class="w-full h-full"
                      />
                    </div>
                  </div>
                </div>

                <div class="text-sm text-base-content">
                  <VanTextEllipsis
                    :content="mateWishItem.content"
                    rows="3"
                    expand-text="展开"
                    collapse-text="收起"
                    class="leading-relaxed"
                  />
                </div>

                <!-- 祈愿主角 -->
                <div v-if="mateWishItem.characterzz?.length" class="space-y-2">
                  <div class="text-xs text-base-content/60 font-medium">
                    {{ $t(`mateWish.lead`) }}
                  </div>
                  <div class="flex gap-2">
                    <div
                      v-for="c in mateWishItem.characterzz.slice(0, 4)"
                      :key="c.mediaUrl"
                      class="w-8 h-10 rounded-md overflow-hidden bg-base-200 flex-shrink-0"
                    >
                      <BaseImg
                        :url="c.mediaUrl"
                        ratio="3:4"
                        fit="cover"
                        class="w-full h-full"
                      />
                    </div>
                    <div
                      v-if="mateWishItem.characterzz.length > 4"
                      class="w-8 h-10 rounded-md bg-base-200 flex items-center justify-center text-xs text-base-content/60"
                    >
                      +{{ mateWishItem.characterzz.length - 4 }}
                    </div>
                  </div>
                </div>

                <!-- 底部操作区域 -->
                <div
                  class="flex items-center justify-between pt-2 border-t border-base-200"
                >
                  <!-- 状态信息 -->
                  <div class="flex-1">
                    <div v-if="mateWishItem.status === 3" class="text-xs">
                      <span class="text-error flex items-center gap-1">
                        <i class="iconify mingcute--warning-line"></i>
                        该内容不合规，请重新选择图片和内容。
                      </span>
                    </div>
                    <div v-else-if="mateWishItem.status === 1" class="text-xs">
                      <span class="text-warning"> 预计回响时间: 1 分钟 </span>
                    </div>
                    <div
                      v-else-if="mateWishItem.status === 0"
                      class="text-xs text-base-content/60"
                    >
                      等待处理中...
                    </div>
                    <div v-else class="text-xs text-success">祈愿已完成</div>
                  </div>

                  <!-- 操作按钮 -->
                  <div v-if="mateWishItem.status === 2">
                    <button
                      class="btn btn-primary btn-sm"
                      @click="clickToDetail(mateWishItem)"
                    >
                      {{ $t(`mateWish.view`) }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </thread-list>
        </VanTab>
      </VanTabs>
    </div>
  </div>
</template>

<script setup lang="ts">
import { readMateWishPage, readOneMateWish } from "@/apis/mate";
import { onActivated, onDeactivated, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { ThreadListInstance } from "../ThreadList.vue";
import { MateWish } from "@/types/entity";
import {
  sessionStorageGet,
  sessionStorageRemove,
} from "@/tools/sessionStorage";
import { StorageGet, StorageSet } from "@/tools/localStorage";
import moment from "moment-timezone";

const showTimeLimitBanner = ref(true);

const statusList = [0, 1, 2];
const router = useRouter();
const status = ref(0);
const listMap = ref<Record<number, MateWish[]>>({
  0: [],
  1: [],
  2: [],
});
const heightMap = ref<Record<number, number>>({
  0: 0,
  1: 0,
  2: 0,
});
const scrollerMap = ref<Record<number, ThreadListInstance | null>>({
  0: null,
  1: null,
  2: null,
});
const reload = async () => {
  const list = listMap.value[status.value];
  list.length = 0;
  scrollerMap.value[status.value]?.resetScrollLoadingState();
};

const loadMateWish = async () => {
  const list = listMap.value[status.value];
  const { length } = list;
  if (length !== 0 && length % 10 !== 0) return false;

  const page = length / 10 + 1;

  const res = await readMateWishPage({
    filter: { status: status.value || undefined },
    pagination: { page, perPage: 10 },
    sort: { field: "dtCreate", order: "desc" },
  });

  res.page.data.forEach((item) => {
    if (item.status === 1 && moment().diff(item.dtCreate, "minutes") <= 5) {
      pendingList.add(item.uuid);
    }

    list.push(item);
  });

  if (pendingList.size > 0) startLoadingPendingList();

  return res.page.data.length === 10;
};

const clickToDetail = (item: MateWish) => {
  router.push({
    name: "mateWishDetail",
    params: { uuid: item.uuid },
  });
};

onActivated(() => {
  if (sessionStorageGet("mate-wish-update")) {
    reload();
    sessionStorageRemove("mate-wish-update");
  } else {
    scrollerMap.value[status.value]?.scrollTo(heightMap.value[status.value]);
  }
});

const clickKnow = () => {
  StorageSet("know:mate-wish-time-limit-banner", 1);
  showTimeLimitBanner.value = false;
};

// 更新管理
let pendingList: Set<string> = new Set();
let timerList: Map<string, NodeJS.Timeout> = new Map();

const startLoadingPendingList = () => {
  pendingList.forEach(checkIsFinished);
};

const checkIsFinished = async (uuid: string) => {
  const res = await readOneMateWish(uuid);
  if (res.item.status === 2) {
    pendingList.delete(uuid);
    timerList.delete(uuid);
    startLoadingPendingList();

    // 全部
    const allIdx = listMap.value[0].findIndex((v) => v.uuid === uuid);
    if (allIdx !== -1) {
      listMap.value[0][allIdx].status = 2;
      listMap.value[0][allIdx].resultImagezz = res.item.resultImagezz;
    }

    // 等待回响
    const waitingIdx = listMap.value[1].findIndex((v) => v.uuid === uuid);
    if (waitingIdx !== -1) {
      listMap.value[1].splice(waitingIdx, 1);
    }

    // 已完成
    if (listMap.value[2].length > 0) {
      listMap.value[2].unshift(res.item);
    }
  } else if (res.item.status === 3) {
    pendingList.delete(uuid);
    timerList.delete(uuid);
    // 全部
    const allIdx = listMap.value[0].findIndex((v) => v.uuid === uuid);
    if (allIdx !== -1) {
      listMap.value[0][allIdx].status = 3;
    }

    // 等待回响
    const waitingIdx = listMap.value[1].findIndex((v) => v.uuid === uuid);
    if (waitingIdx !== -1) {
      listMap.value[1].splice(waitingIdx, 1);
    }
  } else {
    if (timerList.has(uuid)) clearTimeout(timerList.get(uuid));
    timerList.set(
      uuid,
      setTimeout(() => {
        checkIsFinished(uuid);
      }, 3000)
    );
  }
};

onMounted(() => {
  if (StorageGet("know:mate-wish-time-limit-banner")) {
    showTimeLimitBanner.value = false;
  }
});

onDeactivated(() => timerList.forEach((v) => clearTimeout(v)));
</script>

<style scoped>
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

:deep(.mate-wish-home-list .van-tabs__content) {
  height: 100%;
  overflow: hidden;
}
</style>
